import { getMyDiaryDetailsApi } from "@services/MarketWorking/MyTeam/getMyDiaryDetailsApi";
import {
  GET_MYDIARY_DEALER_DETAILS_FAIL,
  GET_MYDIARY_DEALER_DETAILS_SUCCESS,
  GET_MYDIARY_WSS_DETAILS_SUCCESS,
  GET_MYDIARY_WSS_DETAILS_FAIL,
} from "../constants/action-types";
import { setAlert } from "./alert-action";
import { sessionExpireTimeout } from "./utility-actions";

export const getMyDiaryDealerDetails = (dealerCode) => async (dispatch) => {
  const response = await getMyDiaryDetailsApi("Dealer", dealerCode, null);
  if (response?.status === 200) {
    dispatch({
      type: GET_MYDIARY_DEALER_DETAILS_SUCCESS,
      payload: response?.data?.records,
    });
  } else if (response?.error === "ERR_NETWORK") {
    sessionExpireTimeout(dispatch);
  } else {
    dispatch({
      type: GET_MYDIARY_DEALER_DETAILS_FAIL,
    });
    dispatch(setAlert(response?.error, "error"));
  }
};

export const getMyDiaryWSSDetails = (wssCode) => async (dispatch) => {
  const response = await getMyDiaryDetailsApi("WSS", null, wssCode);
  if (response?.status === 200) {
    dispatch({
      type: GET_MYDIARY_WSS_DETAILS_SUCCESS,
      payload: response?.data?.records,
    });
  } else if (response?.error === "ERR_NETWORK") {
    sessionExpireTimeout(dispatch);
  } else {
    dispatch({
      type: GET_MYDIARY_WSS_DETAILS_FAIL,
    });
    dispatch(setAlert(response?.error, "error"));
  }
};
